import React from 'react';
import { ClearableCheckboxDropdown, Table } from 'dyl-components';

const TextHistoryHeader = ({
    recipientOptions,
    senderOptions,
    selectedRecipients,
    selectedSenders,
    onFilter
}) => {
    return (
        <Table.Row>

            <Table.HeaderCell className='TextTabTable__TinyFixedWidth'></Table.HeaderCell>
            <Table.HeaderCell className='TextTabTable__SmallFixedWidth'>Date</Table.HeaderCell>
            <Table.HeaderCell className='TextTabTable__SmallFixedMaxWidth'>
                <ClearableCheckboxDropdown
                    text="To"
                    name="to"
                    options={recipientOptions}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "to", value });
                    }}
                    value={selectedRecipients}
                    closeOnLoad={true}
                />
            </Table.HeaderCell>
            <Table.HeaderCell className='TextTabTable__SmallFixedWidth'>
                <ClearableCheckboxDropdown
                    text="From"
                    name="from"
                    options={senderOptions}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "from", value });
                    }}
                    value={selectedSenders}
                    closeOnLoad={true}
                />
            </Table.HeaderCell>
            <Table.HeaderCell className='TextTabTable__SmallFixedMaxWidth'>Message</Table.HeaderCell>
        </Table.Row>
    );
};

export default TextHistoryHeader;
